<template>
	<div>
		<div class="yl-flex">
			<div class="yl-flex" style="width: 380px">
				<Input v-model="name" style="width: 250px" placeholder="请输入名称">
				<i-button slot="append" icon="ios-search"></i-button>
				</Input>
				<Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
				<Button class='ivu-btn-circle' @click="initSearch">重置</Button>
			</div>
			<Button class='ivu-btn-circle' type="primary" @click="addProduct">添加产品</Button>
		</div>
		<div style="margin-top: 20px;">
			<Table size="small" :columns="columns" :data="data">
				<template slot-scope="{row}" slot="particulars">
					<Button :data-file="row.ext_info.file" @click="introduction" type="warning"
						size="small">产品介绍</Button>
				</template>
				<template slot-scope="{row}" slot="set">
					<Button :data-id="row.id" @click="editProduct" type="primary" size="small">产品匹配设置</Button>
					<Button :data-id="row.id" @click="delProduct" style="margin-left: 10px" size="small">删除</Button>
				</template>
			</Table>
		</div>
		<Modal v-model="AddProductModal" width="1000px" title="新增产品">
			<AddProduct></AddProduct>
		</Modal>
	</div>
</template>

<script>
	import {
		mapActions,
		mapGetters
	} from "vuex";
	import {
		getProductList,
		delProduct
	} from '@/api/runSet';
	import AddProduct from "./AddProduct.vue"

	export default {
		name: "product_manage",
		components: {
			AddProduct
		},
		computed: {
			...mapGetters(['userInfo', 'token']),
		},
		created() {
			this.getList();
		},
		data() {
			return {
				name: '',
				client: {
					name: "",
					phone: "",
					sex: "",
					city: "",
					age: "",
					loans_money: "",
					is_introduce: 1,
				},
				statusFilters: [{
						label: "银行房抵",
						value: "银行房抵",
					},
					{
						label: "民间房抵",
						value: "民间房抵",
					},
					{
						label: "全款车押证",
						value: "工薪贷",
					},
					{
						label: "上门未签约",
						value: "6",
					},
					{
						label: "已签约",
						value: "7",
					},
					{
						label: "进件中",
						value: "8",
					},
					{
						label: "银行拒绝",
						value: "9",
					},
					{
						label: "已回款",
						value: "13",
					},
					{
						label: "资质不符",
						value: "14",
					},
					{
						label: "捣乱申请",
						value: "15",
					},
					{
						label: "外地申请",
						value: "16",
					},
					{
						label: "重复申请",
						value: "17",
					},
				],				
				columns: [{
						title: '产品名称',
						key: 'name',
					},
					{
						title: '所属机构',
						key: 'organization_name',
					},
					{
						title: '产品编号',
						key: 'product_number',
					},
					{
						title: '年华利率',
						key: 'year_rate',
					},
					{
						title: '放款额度',
						key: 'loan_money',
					},
					{
						title: '产品类型',
						key: 'product_type_name',
					},
					{
						title: '还款期限',
						key: 'repayment_period_name',
					},
					{
						title: '还款方式',
						key: 'repayment_way_name',
					},
					{
						title: '市场状态',
						key: 'bazaar_state_name',
					},
					{
						title: '产品详情',
						slot: 'particulars',
					},
					{
						title: '产品设置',
						slot: 'set',
						width: '200'
					}
				],
				data: [],
				AddProductModal:false,
			}
		},

		methods: {
			...mapActions([
				'handleLogOut',
			]),
			search() {
				this.page = 1;
				this.getList();
			},
			initSearch() {
				this.name = '';
				this.page = 1;
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			async getList() {
				let that = this;
				let data = {
					token: that.token,
					page: that.page,
					name: that.name
				};
				let res = await getProductList(that, data);
				if (res.code == 1) {
					that.data = res.data.list;
					that.count = res.count;
				}
			},
			// 产品介绍
			introduction(e) {
				let file = e.currentTarget.dataset.file;
				window.open(file)
			},
			// 添加产品
			addProduct() {
				this.AddProductModal = true;
			},
			// 编辑
			editProduct(e) {
				let id = e.currentTarget.dataset.id;
				window.open('#/AddProduct?id=' + id)
			},
			// 删除
			delProduct(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								id: id
							}
							let res = await delProduct(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.getList();
							}
						}, 1000);
					}
				})
			},
		}
	}
</script>

<style scoped lang="less">
	.yl-flex {
		display: flex;
		justify-content: space-between;
		padding-bottom: 0;
	}

	.add_flex {
		display: flex;
		align-items: center;
		margin: 10px 0;
	}

	.add_title {
		margin: 0 10px;
		font-weight: bold;

	}

	.ivu-upload {
		display: flex;
		align-items: center;
	}
</style>
